// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var CardLast4 = function (x) {
    return x;
};
var tsBridgeCardLast4 = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("CardLast4")("__brandCardLast4"));
    }
};
var writeCardLast4 = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showCardLast4 = Data_Show.showString;
var readCardLast4 = Simple_JSON.readString;
var ordCardLast4 = Data_Ord.ordString;
var newtypeCardLast4 = {
    Coercible0: function () {
        return undefined;
    }
};
var makeCardLast4 = CardLast4;
var eqCardLast4 = Data_Eq.eqString;
export {
    CardLast4,
    makeCardLast4,
    unwrap,
    newtypeCardLast4,
    eqCardLast4,
    ordCardLast4,
    showCardLast4,
    readCardLast4,
    writeCardLast4,
    tsBridgeCardLast4
};
//# sourceMappingURL=index.js.map
